import type {
    TAllRowsAvailable,
    TRowCategory,
    TRowMappingsWithOperatingStatements,
    TRowTotal,
} from "./typesGrids";

export const isRowWithOperatingStatements = (
    row: TAllRowsAvailable,
): row is TRowMappingsWithOperatingStatements => {
    return (
        isRowTotal(row) ||
        Object.prototype.hasOwnProperty.call(row, "originalAccountName")
    );
};
export const isRowTotal = (row: TAllRowsAvailable): row is TRowTotal => {
    return Object.prototype.hasOwnProperty.call(row, "totalName");
};
export const isRowCategory = (row: TAllRowsAvailable): row is TRowCategory => {
    return Object.prototype.hasOwnProperty.call(row, "categoryName");
};
export const isRowOmitted = (row: TAllRowsAvailable): boolean => {
    return "mappingType" in row && row.mappingType === "omit";
};
